import { Banner, Sponsor } from '@/types'
import { PayloadAction, createSlice } from '@reduxjs/toolkit'

interface AppStore {
  sponsorDetails: Sponsor | null
  banner: Banner | null
  isShowMenu: boolean
  isShowDropdown: 'PROFILE' | 'NOTIFY' | 'MESS' | ''
  isGoogleAdsRollout: boolean
  playerSearchAdRateMobile: number
  matchHistoryAdRateMobile: number
  initialMatchesSkippedBeforeFirstAd: number
}

const initialState: AppStore = {
  sponsorDetails: null,
  banner: null,
  isShowMenu: true,
  isShowDropdown: '',
  isGoogleAdsRollout: false,
  playerSearchAdRateMobile: 6,
  matchHistoryAdRateMobile: 6,
  initialMatchesSkippedBeforeFirstAd: 3,
}

const appSlice = createSlice({
  name: 'APP_SLICE',
  initialState,
  reducers: {
    setSponsorsData: (state, action: PayloadAction<Sponsor>) => {
      state.sponsorDetails = action.payload
    },
    setBanner: (state, action: PayloadAction<Banner>) => {
      state.banner = action.payload
    },
    setShowMenu: (state, action: PayloadAction<boolean>) => {
      state.isShowMenu = action.payload
    },
    setShowDropDown: (state, action: PayloadAction<'PROFILE' | 'NOTIFY' | 'MESS' | ''>) => {
      state.isShowDropdown = action.payload
    },
    setIsGoogleAdsRollout: (state, action: PayloadAction<boolean>) => {
      state.isGoogleAdsRollout = action.payload
    },
    setPlayerSearchAdRateMobile: (state, action: PayloadAction<number>) => {
      state.playerSearchAdRateMobile = action.payload
    },
    setMatchHistoryAdRateMobile: (state, action: PayloadAction<number>) => {
      state.matchHistoryAdRateMobile = action.payload
    },
    setInitialMatchesSkippedBeforeFirstAd: (state, action: PayloadAction<number>) => {
      state.initialMatchesSkippedBeforeFirstAd = action.payload
    },
  },
  extraReducers: () => {
    //
  },
})

const { reducer, actions } = appSlice

export const {
  setSponsorsData,
  setShowMenu,
  setShowDropDown,
  setBanner,
  setIsGoogleAdsRollout,
  setPlayerSearchAdRateMobile,
  setMatchHistoryAdRateMobile,
  setInitialMatchesSkippedBeforeFirstAd,
} = actions

export default reducer
